<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useProductPageStore } from "~/stores/main";

const { t } = useI18n();
const store = useProductPageStore();
const { currentImageIndex } = storeToRefs(store);

defineProps<{
  images: string[];
}>();
</script>

<template>
  <div
    class="block lg:hidden relative col-span-2 w-full aspect-square rounded-lg p-5"
    :class="{ 'bg-white': images.length > 0 }"
  >
    <!-- Placeholder image -->
    <img
      v-if="images.length === 0"
      src="/images/Image_placeholder.svg"
      class="image-placeholder mx-auto"
      :alt="t('product_page.images_loading')"
    />

    <!-- (Current) Product image -->
    <NuxtImg
      v-if="images.length > 0"
      v-touch:swipe.left="store.nextImage"
      v-touch:swipe.right="store.previousImage"
      :src="images[currentImageIndex]"
      format="webp"
      :preload="currentImageIndex === 0"
      class="rounded-lg w-full h-auto"
      :width="700"
    ></NuxtImg>

    <!-- Left/right arrows -->
    <button
      v-if="images.length > 0 && currentImageIndex > 0"
      class="flex justify-center items-center w-[34px] h-[34px] absolute left-1.5 top-1/2 -mt-[17px] bg-brand-secondary rounded-full shadow-md"
      @click="store.previousImage"
    >
      <i class="m-icon-arrow-left text-xl ml-[-3px] text-brand-headline"></i>
    </button>
    <button
      v-if="images.length > 0 && currentImageIndex < images.length - 1"
      class="flex justify-center items-center w-[34px] h-[34px] absolute right-1.5 top-1/2 -mt-[17px] bg-brand-secondary rounded-full shadow-md"
      @click="store.nextImage"
    >
      <i class="m-icon-arrow-right text-xl ml-[3px] text-brand-headline"></i>
    </button>

    <!-- Index -->
    <div
      v-if="images.length > 0"
      class="absolute right-3 bottom-2 font-bold text-sm"
    >
      {{ currentImageIndex + 1 }}/{{ images.length }}
    </div>
  </div>
</template>
